import { call, put, takeLatest, select } from "redux-saga/effects";
import { loginSuccess, loginFailure, authTypes } from "../actions/auth";
import { tsV1LoginEndPoint } from "../../configuration";

function* loginSaga(action) {
  try {
    let sessionResponse = yield call(apiLogin, action.payload);
    const {  ORG_ADMIN } = yield select(state => state.auth);
    sessionStorage.setItem("bearer_token", sessionResponse.bearer_token);
      if (sessionResponse?.error) {
      throw new Error(sessionResponse.error_description || "Login failed");
    }

    let permissions = {};
    if(sessionResponse?.role_details[0]?.name === 'SUPER_ADMIN' || sessionResponse?.role_details[0]?.name.includes('ORG_ADMIN')){
      permissions = { ...ORG_ADMIN };
    } 
    sessionResponse.role_details[0].permissions = permissions;
    const billingAccountIds = [];
    if (sessionResponse?.billingaccountids) {
      Object.entries(sessionResponse.billingaccountids).forEach(
        (billingaccountid) => {
          billingAccountIds.push({
            value: billingaccountid[0],
            label: billingaccountid[1],
          });
        }
      );
    }

    const activeSession = {
      firstName: sessionResponse.firstname,
      lastName: sessionResponse.lastname,
      userName: action.payload.userName,
      accountId: "",
      bearerToken: sessionResponse.bearer_token,
      role: sessionResponse?.role_details[0],
      billingAccountIds,
      billingaccountids: sessionResponse?.billingaccountids
    };
    sessionStorage.setItem("activeSession", JSON.stringify(activeSession));
    
    if (billingAccountIds.length < 2) {
      sessionStorage.setItem(
        "activeSession",
        JSON.stringify({
          ...activeSession,
          accountId: sessionResponse.billingaccountid,
        })
      );
      sessionStorage.setItem("accountId", sessionResponse.billingaccountid);
      sessionStorage.setItem("userRole", JSON.stringify(activeSession?.role));
      yield put(
        loginSuccess({ user: {...activeSession, accountId: sessionResponse.billingaccountid}, isOrgSelectorOpen: false, isLogin: true, })
      );
      return;
    }

    yield put(
      loginSuccess({ currentUser: activeSession, isOrgSelectorOpen: true, isLogin: false, })
    );
  } catch (error) {
    yield put(loginFailure(error.message));
  }
}

function apiLogin(credentials) {
  return fetch(tsV1LoginEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      username: credentials.userName,
      password: credentials.password,
      subject_token: "",
    }),
  }).then((response) => response.json());
}

function* checkLogin() {
  try {
    let activeSession = sessionStorage.getItem("activeSession");
    if (!activeSession) {
      yield put(loginFailure(null));
    } else {
      activeSession = JSON.parse(activeSession);
      
      if (activeSession) {
        yield put(loginSuccess({ user: activeSession, isOrgSelectorOpen: false, isLogin: true, }));
      } else {
        yield put(loginFailure(null));
      }
    }
  } catch (error) {
    yield put(loginFailure(error.message));
  }
}

export function* WatchLogin() {
  yield takeLatest(authTypes.WATCH_LOGIN, checkLogin);
}

export default function* AuthSaga() {
  yield takeLatest(authTypes.LOGIN_REQUEST, loginSaga);
}
